import { render } from "./ProcurementDetailsForm.vue?vue&type=template&id=d72d296a&scoped=true"
import script from "./ProcurementDetailsForm.vue?vue&type=script&lang=js"
export * from "./ProcurementDetailsForm.vue?vue&type=script&lang=js"

import "./ProcurementDetailsForm.vue?vue&type=style&index=0&id=d72d296a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72d296a"]])

export default __exports__